import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowRight, Sparkles } from 'lucide-react';
import { CONTACT_ROUTE, DASHBOARD_SIGNIN_URL } from '@/config/links';

const FinalCTA = () => {
  return (
    <section className="relative py-32 bg-gradient-to-br from-blue-800 via-blue-900 to-blue-950 overflow-hidden">
      {/* Decorative Background */}
      <div className="absolute inset-0">
        {/* Animated grid */}
        <div className="absolute inset-0" style={{
          backgroundImage: 'linear-gradient(rgba(255, 255, 255, 0.05) 2px, transparent 2px), linear-gradient(90deg, rgba(255, 255, 255, 0.05) 2px, transparent 2px)',
          backgroundSize: '60px 60px',
          animation: 'gridMove 20s linear infinite'
        }}></div>
        
        {/* Large glowing orbs */}
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-white/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-0 right-1/4 w-[500px] h-[500px] bg-white/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-white/5 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '2s' }}></div>
        
        {/* Geometric shapes */}
        <div className="absolute top-20 right-20 w-32 h-32 border-2 border-white/20 rounded-lg rotate-12 animate-spin" style={{ animationDuration: '20s' }}></div>
        <div className="absolute bottom-20 left-20 w-24 h-24 border-2 border-white/20 rounded-full animate-bounce" style={{ animationDuration: '3s' }}></div>
      </div>

      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="inline-flex items-center space-x-2 bg-white/20 backdrop-blur-sm text-white px-4 py-2 rounded-full mb-6">
          <Sparkles className="w-4 h-4" />
          <span className="text-sm font-semibold">Start Your Journey Today</span>
        </div>
        
        <h2 className="text-5xl md:text-6xl font-bold mb-6 text-white leading-tight">
          Supercharge Your eCommerce
          <br />
          Deliveries with Boxd Logistics!
        </h2>
        
        <p className="text-xl md:text-2xl text-blue-100 mb-12 max-w-3xl mx-auto leading-relaxed">
          Accelerate your growth with seamless, efficient shipping solutions designed to meet the demands of your business. Simplified logistics, happy customers.
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-4 mb-8">
          <Button 
            size="lg" 
            className="bg-white text-blue-900 hover:bg-gray-100 px-10 py-7 text-xl font-bold shadow-2xl"
            onClick={() => { window.location.href = DASHBOARD_SIGNIN_URL; }}
          >
            Start Now <ArrowRight className="ml-2 w-6 h-6" />
          </Button>
          <Button 
            size="lg" 
            variant="outline" 
            className="border-2 border-white text-white hover:bg-white/10 px-10 py-7 text-xl font-bold backdrop-blur-sm"
            onClick={() => window.location.href = CONTACT_ROUTE}
          >
            Contact Sales
          </Button>
        </div>
        
        <p className="text-blue-100 text-sm">
          No commitments, instant access to powerful tools!
        </p>
      </div>
    </section>
  );
};

export default FinalCTA;